import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ViewChild,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  RouterOutlet,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { CourseService } from '@scaffold/services/course.service';
import { VersionControlService } from '@scaffold/services/version-control.service';
import { Subject } from 'rxjs';
import { LtiService } from '@services/lti.service';
import { take, takeUntil } from 'rxjs/operators';
import { HtmldocModalComponent } from '@scaffold/dialogs/htmldoc-modal/htmldoc-modal.component';
import { ScaffoldDialogService } from '@app/framework/dialog/scaffold-dialog.service';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { IframeService } from '@services/iframe.service';
import { TranslationService } from '@services/translation.service';

@Component({
    selector: 'scaffold-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['../../rendered.component.scss', './navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NavigationComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  breadcrumbs = [];
  currentRoute;
  @ViewChild(RouterOutlet, { static: true }) outlet: RouterOutlet;
  isHidden;
  currentVersion;
  tools = [];
  constructor(
    public iframeService: IframeService,
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private viewUpdate: ViewUpdateService,
    private router: Router,
    private titleService: Title,
    private route: ActivatedRoute,
    private courseService: CourseService,
    private versionService: VersionControlService,
    private LTIService: LtiService,
    public dialog: ScaffoldDialogService,
    private translationService: TranslationService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    console.log(this);
    const link = this.item.def_route || this.item.links[0].link;
    this.currentVersion = this.versionService.currentVersion;
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });
    if (link && link.length > 0) {
      this.drawBreadcrumbs();
      const route = this.router.url.split(/\//);

      if ((!route[1] || route[1] != 'views') && route.length <= 3) {
        try {
          this.router.navigate([link], {
            relativeTo: this.route,
          });
        } catch (e) {}
      }
    }

    this.viewUpdate
      .monitorRouteChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe(p => {
        this.setAppTitle(p);
        this.cdr.detectChanges();
      });

    this.currentRoute = this.router.url;

    this.router.events.forEach(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this.router.url;
        this.drawBreadcrumbs();
        this.route.paramMap.pipe(take(1)).subscribe(p => {
          this.setAppTitle(p);
        });
      }
    });
    if (!this.checkDisable() && !this.item.disable_lti) {
      this.LTIService.getToolList()
        .pipe(take(1))
        .subscribe(tools => {
          if (tools.id) {
            this.tools.push(tools);
          } else if (tools.listItems) {
            this.tools = tools.listItems;
          } else if (tools.push) {
            this.tools = tools;
          }
          let tool_buttons = [];
          this.tools.forEach(tool => {
            console.log(tool);
            if (
              tool.data.location &&
              tool.institution_id === this.info.institution_id
            ) {
              tool.button = tool.data.location.find(
                t => t.location_type === 'course_navigation'
              );
              if (tool.button) {
                tool_buttons.push(tool);
              }
            }
          });
          this.tools = tool_buttons;
          console.log(this.tools);
          this.update();
        });
    }
  }

  drawBreadcrumbs() {
    let route = this.router.url.split(/\//);
    this.breadcrumbs = [];
    let nav = '';
    route.forEach((r, i) => {
      if (r && r.length > 0) {
        if (i == 1) {
          this.breadcrumbs.push({
            link: '/' + r,
            text: this.translationService.getTranslatedContent(
              r.split(/\?/)[0]
            ),
            type: this.info.type,
          });
        } else if (i == 2) {
          let link = '../' + r;
          if (this.item.def_route) link += '/' + this.item.def_route;
          this.breadcrumbs.push({
            link: link,
            text: this.translationService.getTranslatedContent(r),
            type: this.info.type,
          });
          nav = '../' + r + '/';
        } else if (i == 3) {
          if (
            this.item.route_overide &&
            route.length > 4 &&
            (r == 'pages' ||
              r == 'assignments' ||
              r == 'discussions' ||
              r == 'quizzes')
          ) {
            r = this.item.route_overide;
          }
          this.breadcrumbs.push({
            link: nav + r,
            text: this.translationService.getTranslatedContent(
              r.split(/\?/)[0]
            ),
            type: this.info.type,
          });
        } else {
          this.breadcrumbs.push({
            link: null,
            text: this.translationService.getTranslatedContent(
              r.split(/\?/)[0]
            ),
          });
        }
      }
    });
    console.log('Breadcrumbs', this.breadcrumbs);
    this.redraw();
  }

  setAppTitle(p) {
    let inRoute;
    this.item.links.forEach(link => {
      if (this.inRoute(link.link)) {
        inRoute = link;
      }
    });
    let root = p.root_title;
    console.log(
      'SET TITLE:',
      (root ? root : '') + (inRoute ? ': ' + inRoute.text : '')
    );
    this.titleService.setTitle(
      (root ? root : '') + (inRoute ? ': ' + inRoute.text : '')
    );
  }

  getTitle(link) {
    if (link?.translation_key) {
      let content = this.translationService.getTranslatedContent(
        link.translation_key
      );
      if (link.text_transform) {
        content = this.translationService.transform(
          content,
          link.translation_key
        );
      }
      if (content) return content;
    }
    let title = link.text;
    if (this.info.id == link.text) return this.info.title || this.info.id;
    if (isNaN(link.text)) {
      if (link.type) {
        title = this.courseService.getTitle(link.text, link.type);
      }
    } else {
      title = this.courseService.getTitle(link.text);
    }
    return title || link.text;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  navigate(event, n) {
    event.preventDefault();
    this.renderedService.openLinkHandler(
      event,
      this.info,
      this.route,
      this.item.link_target
    );
  }

  navRoute(link) {
    this.renderedService.triggerUpdate('Navigating route');
  }
  launch(tool) {
    let info = this.info;
    //  this.src = "https://tuc6cdlir6.execute-api.us-east-2.amazonaws.com/dev/"
    let settings: any = {
      context: {
        data: {
          tool: tool,
          button: tool.button,
          info: info,
        },
      },
    };
    this.dialog.open(HtmldocModalComponent, settings);
  }

  inRoute(route) {
    const regex = new RegExp('/' + route + '(?=/|$)');
    if (this.currentRoute) return this.currentRoute.match(regex);
    else return false;
  }
  toggle(): void {
    this.isHidden = !this.isHidden;
    console.log(this.isHidden);
  }
}
